import Core from '_abstracts/core'

Core.Tasks.add(['user'], () => {
    try {
        const cXenseIDs = {
            'gazetadopovo': '1138596144857280556',
            'semprefamilia': '1138596144857280556',
            'umdoisesportes': '1139722051567259179'
        }

        if (Core.User.get('isLogged')) {
            window.cX = window.cX || {}; window.cX.callQueue = window.cX.callQueue || [];
            
            console.log("window.cX", window.cX)
            console.log("window.ID", cXenseIDs[Core.Config.get('domain')])

            const identityTypes = (Core.User.get('isSubscriber')) ? 'subscriber' : 'registred'

            console.log("cX.user", { 'id': Core.User.get('id'), 'identityTypes': identityTypes, 'type': 'gdp'})

            window.cX.callQueue.push(['addExternalId', { 'id': Core.User.get('id'), 'identityTypes': identityTypes, 'type': 'gdp'}])
            window.cX.callQueue.push(['setSiteId', cXenseIDs[Core.Config.get('domain')]]);
            window.cX.callQueue.push(['sendPageViewEvent']);
        }
    } catch (ex) {
        console.error(ex)
    }
})

